import classNames from 'classnames'
import {memo} from 'react'

import type {BuildId} from '../../../../../types'
import {useDownloadedArtifacts} from '../../../../pages/BuildPage/DependenciesTab/ArtifactDependencies/ArtifactDependencies.utils'
import Files from '../../../Builds/Build/DownloadedDeliveredArtifacts/Files'

import styles from './ArtifactChangeDetails.css'

type Props = {
  className?: string
  from: BuildId
  to: BuildId
  withSmallPadding?: boolean
}

function ArtifactChangeDetails({from, to, withSmallPadding = false}: Props) {
  const files = useDownloadedArtifacts(from, to)
  return files != null ? (
    <div className={classNames(styles.wrapper, {[styles.smallPadding]: withSmallPadding === true})}>
      <Files paths={files} buildId={from} />
    </div>
  ) : null
}

export default memo<Props>(ArtifactChangeDetails)
